import { render, staticRenderFns } from "./DataProduct.vue?vue&type=template&id=26d5c901"
import script from "./DataProduct.vue?vue&type=script&lang=js"
export * from "./DataProduct.vue?vue&type=script&lang=js"
import style0 from "./DataProduct.vue?vue&type=style&index=0&id=26d5c901&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports